"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { useEffect, useRef } from "react";
import FlowAdWrapper from "@components/ads/flow-ad-wrapper";
import Pagination from "@components/common/pagination";
import { useFilterContext } from "@components/filter/filter-context";
import type { DebateListResponse } from "@lib/api/debates/types";
import { routes } from "@lib/navigation";
import { buildSearchParameters } from "@lib/utils/search-params";
import DebateCard from "./debate-card";
interface Props {
  currentPage: number;
  debates: DebateListResponse;
}
export default function DebateList(t0) {
  const $ = _c(24);
  const {
    debates,
    currentPage
  } = t0;
  const hasMounted = useRef(false);
  const router = useRouter();
  const {
    search,
    toggles
  } = useFilterContext();
  let t1;
  let t2;
  if ($[0] !== router || $[1] !== search || $[2] !== toggles) {
    t1 = () => {
      if (!hasMounted.current) {
        hasMounted.current = true;
        return;
      }
      const debounce = setTimeout(() => {
        const query = buildSearchParameters({
          search,
          toggles
        });
        router.replace(`${routes.debates}?${query.toString()}`);
      }, 500);
      return () => {
        clearTimeout(debounce);
      };
    };
    t2 = [router, search, toggles];
    $[0] = router;
    $[1] = search;
    $[2] = toggles;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== router || $[6] !== search || $[7] !== toggles) {
    t3 = function onChangePage(newPage) {
      const query_0 = buildSearchParameters({
        search,
        toggles,
        page: newPage
      });
      router.push(`${routes.debates}?${query_0.toString()}`);
    };
    $[5] = router;
    $[6] = search;
    $[7] = toggles;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onChangePage = t3;
  if (debates.pages === 0) {
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <p className="flex-1 text-center text-xl sm:text-2xl">Inga debatter hittades</p>;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t4;
  if ($[10] !== currentPage || $[11] !== debates.pages || $[12] !== onChangePage) {
    t4 = <Pagination current={currentPage} total={debates.pages} onChange={onChangePage} />;
    $[10] = currentPage;
    $[11] = debates.pages;
    $[12] = onChangePage;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== debates.debates) {
    t5 = debates.debates.map(_temp);
    $[14] = debates.debates;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== currentPage || $[17] !== debates.pages || $[18] !== onChangePage) {
    t6 = <Pagination current={currentPage} total={debates.pages} onChange={onChangePage} className="mt-auto" />;
    $[16] = currentPage;
    $[17] = debates.pages;
    $[18] = onChangePage;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <div className="flex flex-1 flex-col gap-4">{t4}{t5}{t6}</div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}
function _temp(debate, index) {
  return <FlowAdWrapper key={debate.id} index={index}><DebateCard debate={debate} /></FlowAdWrapper>;
}